import axios from "axios";

export default axios.create({
  baseURL: "https://app.formbricks.com/api/v1/client",
});
